import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { loginReset } from "redux/slice/authentication";

// Lead List search text. Kept out of the persisted leadsPage slice so a search does not survive a
// reload; held in the store so a lead record opened from the list can follow the same set.
export interface LeadsPageSearchState {
	term: string;
};

const initialState: LeadsPageSearchState = {
	term: "",
};

export const leadsPageSearchSlice = createSlice({
	name: "leadsPageSearch",
	initialState,
	reducers: {
		setLeadsPageSearchTerm: (state, action: PayloadAction<string>) => {
			state.term = action.payload;
		},
	},
	extraReducers(builder) {
		builder.addCase(loginReset, () => {
			return {...initialState};
		});
	}
});

export const { setLeadsPageSearchTerm } = leadsPageSearchSlice.actions;
